import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
 
export default new Router({
	routes: [
		{path: '/',redirect:'/index'},
		{path: '/index',component:()=>import("./page/index/index.vue"),name:"首页"},
		{path: '/outpatient-payment',component:()=>import("./page/outpatient-payment/index.vue"),name:"门诊缴费"},
		{path: '/outpatient-payment2',component:()=>import("./page/outpatient-payment/index2.vue"),name:"门诊缴费2"},
		{path: '/print',component:()=>import("./page/print/index.vue"),name:"报告打印"},
		{path: '/hospital-list',component:()=>import("./page/hospital-list/index.vue"),name:"住院清单"},
		{path: '/hospital-payCost',component:()=>import("./page/hospital-payCost/index.vue"),name:"住院预缴"},
		{path: '/outpatient-department-list',component:()=>import("./page/outpatient-department-list/index.vue"),name:"门诊清单"},
		{path: '/invoice-print',component:()=>import("./page/print/invoice-print.vue"),name:"发票打印"},
		
		{path: '/choose-department',component:()=>import("./page/choose-department/index.vue"),name:"选择科室"},
		
		{path: '/choose-doctor',component:()=>import("./page/choose-doctor/index.vue"),name:"选择医师"},
		{path: '/choose-doctor2',component:()=>import("./page/choose-doctor/index2.vue"),name:"选择医师2"},
		{path: '/choose-time',component:()=>import("./page/choose-time/index.vue"),name:"选择时间"},
		
		{path: '/book-payCost',component:()=>import("./page/book-payCost/index.vue"),name:"预约缴费"},
		{path: '/clinic-payCost',component:()=>import("./page/clinic-payCost/index.vue"),name:"门诊缴费3"},
		{path: '/nucleic-acid',component:()=>import("./page/nucleic-acid/index.vue"),name:"自助核酸"},
		{path: '/nucleic-acid2',component:()=>import("./page/nucleic-acid/index2.vue"),name:"自助核酸2"},
		{path: '/self-pay',component:()=>import("./page/nucleic-acid/pay.vue"),name:"自费结算"},
		
		
		{path: '/take-num',component:()=>import("./page/take-num/index.vue"),name:"预约取号"},
		{path: '/book-register',component:()=>import("./page/book-register/index.vue"),name:"预约挂号"},
		{path: '/searchIndex',component:()=>import("./page/index/searchIndex.vue"),name:"综合查询"},
		
		{path: '/shop-price',component:()=>import("./page/index/shop-price.vue"),name:"物价查询"},
		{path: '/about',component:()=>import("./page/about/index.vue"),name:"医院简介"},
		
	
		
		
	]
})